import { Field } from '@approvalmax/ui';
import styled from 'styled-components';

export const Root = styled.div`
    display: flex;
    flex-flow: row wrap;
    margin-right: -20px;
`;

export const StyledField = styled(Field)`
    flex: 1;
    min-width: 200px;
    max-width: 200px;
    margin-top: 20px;
    margin-right: 20px;
`;
